const environment = {
  // apiUrl: 'https://1w3n8aao3j.execute-api.us-east-2.amazonaws.com/dev',
  apiUrl: 'https://l2wp8df1a2.execute-api.us-east-2.amazonaws.com/prod',
};

const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
async function postDataLogin(endpoint, data) {
  try {
    const response = await fetch(`${environment.apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
      // body: data,
    });

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error posting data:', error);
  }
}

async function postData (endpoint, data) {
  try {
    const response = await fetch(`${environment.apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
         'tkn': JSON.parse(localStorage.getItem('ai-admin'))?.at
        //  'tkn': aminInfo?.at
      },
      body: JSON.stringify(data),
      // body: data,
    });

    // const responseData = await response.json();
    return response;
  } catch (error) {
    console.error('Error posting data:', error);
  }
}

async function postDataUser(endpoint, data) {
  try {
    const response = await fetch(`${environment.apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        //  'tkn': aminInfo.at //Needs to send access token
      },
      body: JSON.stringify(data),
      // body: data,
    });

    // const responseData = await response.json();
    return response;
  } catch (error) {
    console.error('Error posting data:', error);
  }
}

async function postFormData(endpoint, data) {
  try {
    const response = await fetch(`${environment.apiUrl}/${endpoint}`, {
      method: 'POST',
      headers: {
        // Important: Set the Content-Type header to 'multipart/form-data'
        'Content-Type': 'multipart/form-data,boundary=${formData._boundary}',
        // Include any other necessary headers (e.g., Authorization headers if needed)
      },
      body: data,
      // body: data,
    });

    // const responseData = await response.json();
    return response;
  } catch (error) {
    console.error('Error posting data:', error);
  }
}



export { postDataLogin, postData,postFormData,postDataUser};
